@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(-70_284_061)
public val Res.string.explain_spmh_hours_worked: StringResource by lazy {
      StringResource("string:explain_spmh_hours_worked", "explain_spmh_hours_worked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 133117, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 187605, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120748, 49),
      ))
    }

@delegate:ResourceContentHash(468_547_996)
public val Res.string.explain_spmh_planned_note: StringResource by lazy {
      StringResource("string:explain_spmh_planned_note", "explain_spmh_planned_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 133179, 165),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 187691, 233),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120798, 117),
      ))
    }

@delegate:ResourceContentHash(-506_493_294)
public val Res.string.explain_term_base_pay: StringResource by lazy {
      StringResource("string:explain_term_base_pay", "explain_term_base_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 133345, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 187925, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120916, 73),
      ))
    }

@delegate:ResourceContentHash(-1_087_369_367)
public val Res.string.explain_term_bonuses: StringResource by lazy {
      StringResource("string:explain_term_bonuses", "explain_term_bonuses", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 133423, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 188019, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120990, 40),
      ))
    }

@delegate:ResourceContentHash(1_512_515_223)
public val Res.string.explain_term_commission: StringResource by lazy {
      StringResource("string:explain_term_commission", "explain_term_commission", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 133460, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 188064, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121031, 47),
      ))
    }

@delegate:ResourceContentHash(-1_981_176_749)
public val Res.string.explain_term_deductions: StringResource by lazy {
      StringResource("string:explain_term_deductions", "explain_term_deductions", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 133504, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 188116, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121079, 47),
      ))
    }

@delegate:ResourceContentHash(1_223_521_023)
public val Res.string.explain_term_employer_contributions: StringResource by lazy {
      StringResource("string:explain_term_employer_contributions", "explain_term_employer_contributions", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 133552, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 188172, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121127, 79),
      ))
    }

@delegate:ResourceContentHash(1_431_128_071)
public val Res.string.explain_term_expected_sales: StringResource by lazy {
      StringResource("string:explain_term_expected_sales", "explain_term_expected_sales", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 133624, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 188264, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121207, 55),
      ))
    }

@delegate:ResourceContentHash(693_093_076)
public val Res.string.explain_term_expense_refunds: StringResource by lazy {
      StringResource("string:explain_term_expense_refunds", "explain_term_expense_refunds", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 133688, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 188344, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121263, 56),
      ))
    }

@delegate:ResourceContentHash(-1_231_246_151)
public val Res.string.explain_term_holiday_pay: StringResource by lazy {
      StringResource("string:explain_term_holiday_pay", "explain_term_holiday_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 133749, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 188433, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121320, 44),
      ))
    }

@delegate:ResourceContentHash(-1_315_038_269)
public val Res.string.explain_term_hours_at_month_average: StringResource by lazy {
      StringResource("string:explain_term_hours_at_month_average", "explain_term_hours_at_month_average", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 133814, 103),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 188510, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121365, 95),
      ))
    }

@delegate:ResourceContentHash(-565_122_657)
public val Res.string.explain_term_hours_at_own_rate: StringResource by lazy {
      StringResource("string:explain_term_hours_at_own_rate", "explain_term_hours_at_own_rate", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 133918, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 188646, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121461, 98),
      ))
    }

@delegate:ResourceContentHash(-1_855_429_482)
public val Res.string.explain_term_hours_at_team_average: StringResource by lazy {
      StringResource("string:explain_term_hours_at_team_average", "explain_term_hours_at_team_average", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 134021, 98),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 188793, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121560, 94),
      ))
    }

@delegate:ResourceContentHash(1_577_027_473)
public val Res.string.explain_term_minimum_wage_top_up: StringResource by lazy {
      StringResource("string:explain_term_minimum_wage_top_up", "explain_term_minimum_wage_top_up", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 134120, 84),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 188928, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121655, 68),
      ))
    }

@delegate:ResourceContentHash(2_042_046_245)
public val Res.string.explain_term_net_sales_kept: StringResource by lazy {
      StringResource("string:explain_term_net_sales_kept", "explain_term_net_sales_kept", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 134205, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 189049, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121724, 71),
      ))
    }

@delegate:ResourceContentHash(-1_759_454_739)
public val Res.string.explain_term_night_allowance: StringResource by lazy {
      StringResource("string:explain_term_night_allowance", "explain_term_night_allowance", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 134281, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 189153, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121796, 64),
      ))
    }

@delegate:ResourceContentHash(-939_857_015)
public val Res.string.explain_term_open_shifts: StringResource by lazy {
      StringResource("string:explain_term_open_shifts", "explain_term_open_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 134422, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 189334, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121929, 72),
      ))
    }

@delegate:ResourceContentHash(1_006_323_711)
public val Res.string.explain_term_open_shifts_not_priced: StringResource by lazy {
      StringResource("string:explain_term_open_shifts_not_priced", "explain_term_open_shifts_not_priced", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 134350, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 189250, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121861, 67),
      ))
    }

@delegate:ResourceContentHash(1_333_858_801)
public val Res.string.explain_term_other_costs: StringResource by lazy {
      StringResource("string:explain_term_other_costs", "explain_term_other_costs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 134499, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 189439, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122002, 48),
      ))
    }

@delegate:ResourceContentHash(-784_101_913)
public val Res.string.explain_term_overtime_100: StringResource by lazy {
      StringResource("string:explain_term_overtime_100", "explain_term_overtime_100", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 134556, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 189504, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122051, 65),
      ))
    }

@delegate:ResourceContentHash(-1_297_788_856)
public val Res.string.explain_term_overtime_50: StringResource by lazy {
      StringResource("string:explain_term_overtime_50", "explain_term_overtime_50", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 134626, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 189606, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122117, 64),
      ))
    }

@delegate:ResourceContentHash(891_708_794)
public val Res.string.explain_term_overtime_pay: StringResource by lazy {
      StringResource("string:explain_term_overtime_pay", "explain_term_overtime_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 134695, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 189703, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122182, 49),
      ))
    }

@delegate:ResourceContentHash(-616_107_596)
public val Res.string.explain_term_paid_by_zus: StringResource by lazy {
      StringResource("string:explain_term_paid_by_zus", "explain_term_paid_by_zus", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 134765, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 189789, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122232, 72),
      ))
    }

@delegate:ResourceContentHash(-530_197_092)
public val Res.string.explain_term_planned_shifts: StringResource by lazy {
      StringResource("string:explain_term_planned_shifts", "explain_term_planned_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 134834, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 189890, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122305, 55),
      ))
    }

@delegate:ResourceContentHash(-458_439_799)
public val Res.string.explain_term_rate_change: StringResource by lazy {
      StringResource("string:explain_term_rate_change", "explain_term_rate_change", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 134894, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 189970, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122361, 72),
      ))
    }

@delegate:ResourceContentHash(964_269_600)
public val Res.string.explain_term_revenue_items: StringResource by lazy {
      StringResource("string:explain_term_revenue_items", "explain_term_revenue_items", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 134983, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 190075, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122434, 66),
      ))
    }

@delegate:ResourceContentHash(-556_531_260)
public val Res.string.explain_term_rounding: StringResource by lazy {
      StringResource("string:explain_term_rounding", "explain_term_rounding", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 135058, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 190170, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122501, 41),
      ))
    }

@delegate:ResourceContentHash(-316_190_970)
public val Res.string.explain_term_salary_reduction: StringResource by lazy {
      StringResource("string:explain_term_salary_reduction", "explain_term_salary_reduction", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 135108, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 190228, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122543, 85),
      ))
    }

@delegate:ResourceContentHash(-414_246_847)
public val Res.string.explain_term_sales_income_mixed: StringResource by lazy {
      StringResource("string:explain_term_sales_income_mixed", "explain_term_sales_income_mixed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 135194, 91),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 190342, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122629, 99),
      ))
    }

@delegate:ResourceContentHash(-1_799_760_364)
public val Res.string.explain_term_saved_earlier: StringResource by lazy {
      StringResource("string:explain_term_saved_earlier", "explain_term_saved_earlier", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 135286, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 190470, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122729, 82),
      ))
    }

@delegate:ResourceContentHash(957_802_504)
public val Res.string.explain_term_shift_gross: StringResource by lazy {
      StringResource("string:explain_term_shift_gross", "explain_term_shift_gross", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 135389, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 190589, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122812, 44),
      ))
    }

@delegate:ResourceContentHash(1_228_799_154)
public val Res.string.explain_term_shift_snapshot: StringResource by lazy {
      StringResource("string:explain_term_shift_snapshot", "explain_term_shift_snapshot", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 135450, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 190658, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122857, 67),
      ))
    }

@delegate:ResourceContentHash(51_490_565)
public val Res.string.explain_term_sick_benefit: StringResource by lazy {
      StringResource("string:explain_term_sick_benefit", "explain_term_sick_benefit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 135514, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 190758, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122925, 65),
      ))
    }

@delegate:ResourceContentHash(-1_216_827_886)
public val Res.string.explain_term_sick_pay: StringResource by lazy {
      StringResource("string:explain_term_sick_pay", "explain_term_sick_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 135580, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 190848, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122991, 65),
      ))
    }

@delegate:ResourceContentHash(878_064_805)
public val Res.string.explain_term_sunday_holiday: StringResource by lazy {
      StringResource("string:explain_term_sunday_holiday", "explain_term_sunday_holiday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 135642, 91),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 190966, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123057, 75),
      ))
    }

@delegate:ResourceContentHash(246_737_367)
public val Res.string.explain_term_supplements_change: StringResource by lazy {
      StringResource("string:explain_term_supplements_change", "explain_term_supplements_change", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 135734, 167),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 191090, 231),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123133, 151),
      ))
    }

@delegate:ResourceContentHash(-507_720_258)
public val Res.string.explain_term_takings_file: StringResource by lazy {
      StringResource("string:explain_term_takings_file", "explain_term_takings_file", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 135902, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 191322, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123285, 73),
      ))
    }

@delegate:ResourceContentHash(540_089_272)
public val Res.string.explain_term_takings_till: StringResource by lazy {
      StringResource("string:explain_term_takings_till", "explain_term_takings_till", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 135972, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 191428, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123359, 61),
      ))
    }

@delegate:ResourceContentHash(1_353_198_949)
public val Res.string.explain_term_takings_typed: StringResource by lazy {
      StringResource("string:explain_term_takings_typed", "explain_term_takings_typed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 136022, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 191494, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123421, 54),
      ))
    }

@delegate:ResourceContentHash(2_103_560_135)
public val Res.string.explain_term_taxes_and_contributions: StringResource by lazy {
      StringResource("string:explain_term_taxes_and_contributions", "explain_term_taxes_and_contributions", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 136077, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 191569, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123476, 76),
      ))
    }

@delegate:ResourceContentHash(-165_872_936)
public val Res.string.explain_term_without_pay_shifts: StringResource by lazy {
      StringResource("string:explain_term_without_pay_shifts", "explain_term_without_pay_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 136146, 95),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 191654, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123553, 83),
      ))
    }

@delegate:ResourceContentHash(-1_641_193_974)
public val Res.string.explain_total: StringResource by lazy {
      StringResource("string:explain_total", "explain_total", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 136242, 29),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 191774, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123637, 29),
      ))
    }

@delegate:ResourceContentHash(-812_356_130)
public val Res.string.export_choice_subtitle: StringResource by lazy {
      StringResource("string:export_choice_subtitle", "export_choice_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 136272, 122),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 191812, 194),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123667, 114),
      ))
    }

@delegate:ResourceContentHash(-998_030_367)
public val Res.string.export_col_bonuses: StringResource by lazy {
      StringResource("string:export_col_bonuses", "export_col_bonuses", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 136395, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 192007, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123782, 62),
      ))
    }

@delegate:ResourceContentHash(792_641_513)
public val Res.string.export_col_clocked_hours: StringResource by lazy {
      StringResource("string:export_col_clocked_hours", "export_col_clocked_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 136458, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 192098, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123845, 52),
      ))
    }

@delegate:ResourceContentHash(-811_018_599)
public val Res.string.export_col_contract: StringResource by lazy {
      StringResource("string:export_col_contract", "export_col_contract", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 136523, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 192183, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123898, 39),
      ))
    }

@delegate:ResourceContentHash(-1_405_021_638)
public val Res.string.export_col_currency: StringResource by lazy {
      StringResource("string:export_col_currency", "export_col_currency", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 136559, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 192231, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123938, 39),
      ))
    }

@delegate:ResourceContentHash(-1_981_176_749)
public val Res.string.export_col_deductions: StringResource by lazy {
      StringResource("string:export_col_deductions", "export_col_deductions", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 136595, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 192275, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123978, 45),
      ))
    }

@delegate:ResourceContentHash(1_526_181_073)
public val Res.string.export_col_employee: StringResource by lazy {
      StringResource("string:export_col_employee", "export_col_employee", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 136641, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 192329, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124024, 39),
      ))
    }

@delegate:ResourceContentHash(-214_335_429)
public val Res.string.export_col_employer_cost: StringResource by lazy {
      StringResource("string:export_col_employer_cost", "export_col_employer_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 136751, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 192483, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124130, 52),
      ))
    }

@delegate:ResourceContentHash(-2_049_122_093)
public val Res.string.export_col_employer_cost_plan: StringResource by lazy {
      StringResource("string:export_col_employer_cost_plan", "export_col_employer_cost_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 136681, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 192381, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124064, 65),
      ))
    }

@delegate:ResourceContentHash(1_388_174_366)
public val Res.string.export_col_gross: StringResource by lazy {
      StringResource("string:export_col_gross", "export_col_gross", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 136808, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 192568, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124183, 44),
      ))
    }

@delegate:ResourceContentHash(-2_053_923_554)
public val Res.string.export_col_holiday_pay: StringResource by lazy {
      StringResource("string:export_col_holiday_pay", "export_col_holiday_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 136857, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 192637, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124228, 46),
      ))
    }

@delegate:ResourceContentHash(1_347_388_290)
public val Res.string.export_col_minimum_top_up: StringResource by lazy {
      StringResource("string:export_col_minimum_top_up", "export_col_minimum_top_up", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 136920, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 192692, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124275, 61),
      ))
    }

@delegate:ResourceContentHash(-809_964_435)
public val Res.string.export_col_month: StringResource by lazy {
      StringResource("string:export_col_month", "export_col_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 136998, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 192806, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124337, 32),
      ))
    }

@delegate:ResourceContentHash(566_907_350)
public val Res.string.export_col_overtime_100: StringResource by lazy {
      StringResource("string:export_col_overtime_100", "export_col_overtime_100", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 137035, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 192847, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124370, 59),
      ))
    }

@delegate:ResourceContentHash(-844_837_858)
public val Res.string.export_col_overtime_50: StringResource by lazy {
      StringResource("string:export_col_overtime_50", "export_col_overtime_50", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 137103, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 192931, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124430, 54),
      ))
    }

@delegate:ResourceContentHash(1_861_745_142)
public val Res.string.export_col_paid_hours: StringResource by lazy {
      StringResource("string:export_col_paid_hours", "export_col_paid_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 137166, 105),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 193014, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124485, 73),
      ))
    }

@delegate:ResourceContentHash(-1_941_560_766)
public val Res.string.export_col_planned_gross: StringResource by lazy {
      StringResource("string:export_col_planned_gross", "export_col_planned_gross", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 137272, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 193164, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124559, 64),
      ))
    }

@delegate:ResourceContentHash(-191_171_272)
public val Res.string.export_col_planned_hours: StringResource by lazy {
      StringResource("string:export_col_planned_hours", "export_col_planned_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 137337, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 193257, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124624, 52),
      ))
    }

@delegate:ResourceContentHash(693_093_076)
public val Res.string.export_col_refunds: StringResource by lazy {
      StringResource("string:export_col_refunds", "export_col_refunds", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 137394, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 193338, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124677, 46),
      ))
    }

@delegate:ResourceContentHash(-1_328_591_861)
public val Res.string.export_col_sick_days: StringResource by lazy {
      StringResource("string:export_col_sick_days", "export_col_sick_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 137445, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 193417, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124724, 48),
      ))
    }

@delegate:ResourceContentHash(384_362_636)
public val Res.string.export_col_sick_pay: StringResource by lazy {
      StringResource("string:export_col_sick_pay", "export_col_sick_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 137510, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 193486, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124773, 59),
      ))
    }

@delegate:ResourceContentHash(-1_211_142_279)
public val Res.string.export_col_sunday_holiday: StringResource by lazy {
      StringResource("string:export_col_sunday_holiday", "export_col_sunday_holiday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 137586, 97),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 193590, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124833, 89),
      ))
    }

@delegate:ResourceContentHash(-883_048_330)
public val Res.string.export_col_supplements: StringResource by lazy {
      StringResource("string:export_col_supplements", "export_col_supplements", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 137684, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 193736, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124923, 70),
      ))
    }

@delegate:ResourceContentHash(432_834_430)
public val Res.string.export_col_vacation_days: StringResource by lazy {
      StringResource("string:export_col_vacation_days", "export_col_vacation_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 137767, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 193839, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124994, 56),
      ))
    }

@delegate:ResourceContentHash(-17_722_174)
public val Res.string.export_download: StringResource by lazy {
      StringResource("string:export_download", "export_download", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 137816, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 193928, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125051, 35),
      ))
    }

@delegate:ResourceContentHash(1_711_747_632)
public val Res.string.export_limit_reached: StringResource by lazy {
      StringResource("string:export_limit_reached", "export_limit_reached", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 137852, 108),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 193984, 188),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125087, 108),
      ))
    }

@delegate:ResourceContentHash(988_216_735)
public val Res.string.export_my_data: StringResource by lazy {
      StringResource("string:export_my_data", "export_my_data", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 138337, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 194737, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125500, 46),
      ))
    }

@delegate:ResourceContentHash(1_876_819_680)
public val Res.string.export_my_data_text: StringResource by lazy {
      StringResource("string:export_my_data_text", "export_my_data_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 137961, 375),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 194173, 563),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125196, 303),
      ))
    }

@delegate:ResourceContentHash(1_461_770_439)
public val Res.string.export_ready_text: StringResource by lazy {
      StringResource("string:export_ready_text", "export_ready_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 138384, 121),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 194812, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125547, 121),
      ))
    }

@delegate:ResourceContentHash(-1_875_336_378)
public val Res.string.export_ready_title: StringResource by lazy {
      StringResource("string:export_ready_title", "export_ready_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 138506, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 194986, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125669, 54),
      ))
    }

@delegate:ResourceContentHash(-145_068_422)
public val Res.string.export_save_as: StringResource by lazy {
      StringResource("string:export_save_as", "export_save_as", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 138561, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 195061, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125724, 38),
      ))
    }

@delegate:ResourceContentHash(-267_583_331)
public val Res.string.export_save_failed: StringResource by lazy {
      StringResource("string:export_save_failed", "export_save_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 138604, 122),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 195116, 166),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125763, 106),
      ))
    }

@delegate:ResourceContentHash(280_954_012)
public val Res.string.export_saved: StringResource by lazy {
      StringResource("string:export_saved", "export_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 138727, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 195283, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125870, 36),
      ))
    }

@delegate:ResourceContentHash(-1_521_099_470)
public val Res.string.export_share: StringResource by lazy {
      StringResource("string:export_share", "export_share", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 138772, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 195348, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125907, 28),
      ))
    }

@delegate:ResourceContentHash(-145_162_894)
public val Res.string.export_sign_in_again: StringResource by lazy {
      StringResource("string:export_sign_in_again", "export_sign_in_again", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 139115, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 195871, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126206, 48),
      ))
    }

@delegate:ResourceContentHash(-1_346_460_222)
public val Res.string.export_sign_in_again_text: StringResource by lazy {
      StringResource("string:export_sign_in_again_text", "export_sign_in_again_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 138809, 305),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 195397, 473),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125936, 269),
      ))
    }

@delegate:ResourceContentHash(436_588_544)
public val Res.string.export_sign_out: StringResource by lazy {
      StringResource("string:export_sign_out", "export_sign_out", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 139172, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 195932, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126255, 35),
      ))
    }

@delegate:ResourceContentHash(128_873_679)
public val Res.string.export_working: StringResource by lazy {
      StringResource("string:export_working", "export_working", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 139212, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 195972, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126291, 54),
      ))
    }

@delegate:ResourceContentHash(-1_512_697_102)
public val Res.string.export_workplace: StringResource by lazy {
      StringResource("string:export_workplace", "export_workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 139673, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 196697, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126676, 52),
      ))
    }

@delegate:ResourceContentHash(1_899_099_921)
public val Res.string.export_workplace_text: StringResource by lazy {
      StringResource("string:export_workplace_text", "export_workplace_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 139271, 401),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 196035, 661),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126346, 329),
      ))
    }

@delegate:ResourceContentHash(164_076_435)
public val Res.string.feature_announcements: StringResource by lazy {
      StringResource("string:feature_announcements", "feature_announcements", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 139726, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 196786, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126729, 49),
      ))
    }

@delegate:ResourceContentHash(-749_063_526)
public val Res.string.feature_availability: StringResource by lazy {
      StringResource("string:feature_availability", "feature_availability", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 139772, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 196844, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126779, 44),
      ))
    }

@delegate:ResourceContentHash(-917_620_120)
public val Res.string.feature_checklists: StringResource by lazy {
      StringResource("string:feature_checklists", "feature_checklists", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 139825, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 196905, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126824, 42),
      ))
    }

@delegate:ResourceContentHash(1_390_597_567)
public val Res.string.feature_clock: StringResource by lazy {
      StringResource("string:feature_clock", "feature_clock", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 139868, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 196956, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126867, 65),
      ))
    }

@delegate:ResourceContentHash(798_041_637)
public val Res.string.feature_finances: StringResource by lazy {
      StringResource("string:feature_finances", "feature_finances", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 139930, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 197058, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126933, 48),
      ))
    }

@delegate:ResourceContentHash(1_179_730_184)
public val Res.string.feature_hiring: StringResource by lazy {
      StringResource("string:feature_hiring", "feature_hiring", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 139979, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 197131, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126982, 30),
      ))
    }

@delegate:ResourceContentHash(1_668_507_438)
public val Res.string.feature_pay: StringResource by lazy {
      StringResource("string:feature_pay", "feature_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 140018, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 197194, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127013, 51),
      ))
    }

@delegate:ResourceContentHash(-843_455_231)
public val Res.string.feature_reports: StringResource by lazy {
      StringResource("string:feature_reports", "feature_reports", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 140066, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 197270, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127065, 47),
      ))
    }

@delegate:ResourceContentHash(-1_726_414_795)
public val Res.string.feature_requests: StringResource by lazy {
      StringResource("string:feature_requests", "feature_requests", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 140114, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 197326, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127113, 52),
      ))
    }

@delegate:ResourceContentHash(1_812_261_336)
public val Res.string.feature_roster: StringResource by lazy {
      StringResource("string:feature_roster", "feature_roster", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 140171, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 197403, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127166, 46),
      ))
    }

@delegate:ResourceContentHash(1_227_137_100)
public val Res.string.feature_settings: StringResource by lazy {
      StringResource("string:feature_settings", "feature_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 140214, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 197462, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127213, 48),
      ))
    }

@delegate:ResourceContentHash(-2_051_114_157)
public val Res.string.feature_takings: StringResource by lazy {
      StringResource("string:feature_takings", "feature_takings", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 140263, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 197539, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127262, 35),
      ))
    }

@delegate:ResourceContentHash(-2_004_102_002)
public val Res.string.feature_team: StringResource by lazy {
      StringResource("string:feature_team", "feature_team", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 140295, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 197579, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127298, 28),
      ))
    }

@delegate:ResourceContentHash(-902_075_048)
public val Res.string.feature_templates: StringResource by lazy {
      StringResource("string:feature_templates", "feature_templates", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 140328, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 197620, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127327, 45),
      ))
    }

@delegate:ResourceContentHash(-1_274_481_675)
public val Res.string.feature_tips: StringResource by lazy {
      StringResource("string:feature_tips", "feature_tips", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 140374, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 197678, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127373, 28),
      ))
    }

@delegate:ResourceContentHash(-596_751_378)
public val Res.string.feature_training: StringResource by lazy {
      StringResource("string:feature_training", "feature_training", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 140407, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 197715, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127402, 64),
      ))
    }

@delegate:ResourceContentHash(-1_848_214_819)
public val Res.string.field_required: StringResource by lazy {
      StringResource("string:field_required", "field_required", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 140452, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 197804, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127467, 34),
      ))
    }

@delegate:ResourceContentHash(-980_280_086)
public val Res.string.file_drop_here: StringResource by lazy {
      StringResource("string:file_drop_here", "file_drop_here", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 140487, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 197859, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127502, 46),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString16Resources(map: MutableMap<String, StringResource>) {
  map.put("explain_spmh_hours_worked", Res.string.explain_spmh_hours_worked)
  map.put("explain_spmh_planned_note", Res.string.explain_spmh_planned_note)
  map.put("explain_term_base_pay", Res.string.explain_term_base_pay)
  map.put("explain_term_bonuses", Res.string.explain_term_bonuses)
  map.put("explain_term_commission", Res.string.explain_term_commission)
  map.put("explain_term_deductions", Res.string.explain_term_deductions)
  map.put("explain_term_employer_contributions", Res.string.explain_term_employer_contributions)
  map.put("explain_term_expected_sales", Res.string.explain_term_expected_sales)
  map.put("explain_term_expense_refunds", Res.string.explain_term_expense_refunds)
  map.put("explain_term_holiday_pay", Res.string.explain_term_holiday_pay)
  map.put("explain_term_hours_at_month_average", Res.string.explain_term_hours_at_month_average)
  map.put("explain_term_hours_at_own_rate", Res.string.explain_term_hours_at_own_rate)
  map.put("explain_term_hours_at_team_average", Res.string.explain_term_hours_at_team_average)
  map.put("explain_term_minimum_wage_top_up", Res.string.explain_term_minimum_wage_top_up)
  map.put("explain_term_net_sales_kept", Res.string.explain_term_net_sales_kept)
  map.put("explain_term_night_allowance", Res.string.explain_term_night_allowance)
  map.put("explain_term_open_shifts", Res.string.explain_term_open_shifts)
  map.put("explain_term_open_shifts_not_priced", Res.string.explain_term_open_shifts_not_priced)
  map.put("explain_term_other_costs", Res.string.explain_term_other_costs)
  map.put("explain_term_overtime_100", Res.string.explain_term_overtime_100)
  map.put("explain_term_overtime_50", Res.string.explain_term_overtime_50)
  map.put("explain_term_overtime_pay", Res.string.explain_term_overtime_pay)
  map.put("explain_term_paid_by_zus", Res.string.explain_term_paid_by_zus)
  map.put("explain_term_planned_shifts", Res.string.explain_term_planned_shifts)
  map.put("explain_term_rate_change", Res.string.explain_term_rate_change)
  map.put("explain_term_revenue_items", Res.string.explain_term_revenue_items)
  map.put("explain_term_rounding", Res.string.explain_term_rounding)
  map.put("explain_term_salary_reduction", Res.string.explain_term_salary_reduction)
  map.put("explain_term_sales_income_mixed", Res.string.explain_term_sales_income_mixed)
  map.put("explain_term_saved_earlier", Res.string.explain_term_saved_earlier)
  map.put("explain_term_shift_gross", Res.string.explain_term_shift_gross)
  map.put("explain_term_shift_snapshot", Res.string.explain_term_shift_snapshot)
  map.put("explain_term_sick_benefit", Res.string.explain_term_sick_benefit)
  map.put("explain_term_sick_pay", Res.string.explain_term_sick_pay)
  map.put("explain_term_sunday_holiday", Res.string.explain_term_sunday_holiday)
  map.put("explain_term_supplements_change", Res.string.explain_term_supplements_change)
  map.put("explain_term_takings_file", Res.string.explain_term_takings_file)
  map.put("explain_term_takings_till", Res.string.explain_term_takings_till)
  map.put("explain_term_takings_typed", Res.string.explain_term_takings_typed)
  map.put("explain_term_taxes_and_contributions", Res.string.explain_term_taxes_and_contributions)
  map.put("explain_term_without_pay_shifts", Res.string.explain_term_without_pay_shifts)
  map.put("explain_total", Res.string.explain_total)
  map.put("export_choice_subtitle", Res.string.export_choice_subtitle)
  map.put("export_col_bonuses", Res.string.export_col_bonuses)
  map.put("export_col_clocked_hours", Res.string.export_col_clocked_hours)
  map.put("export_col_contract", Res.string.export_col_contract)
  map.put("export_col_currency", Res.string.export_col_currency)
  map.put("export_col_deductions", Res.string.export_col_deductions)
  map.put("export_col_employee", Res.string.export_col_employee)
  map.put("export_col_employer_cost", Res.string.export_col_employer_cost)
  map.put("export_col_employer_cost_plan", Res.string.export_col_employer_cost_plan)
  map.put("export_col_gross", Res.string.export_col_gross)
  map.put("export_col_holiday_pay", Res.string.export_col_holiday_pay)
  map.put("export_col_minimum_top_up", Res.string.export_col_minimum_top_up)
  map.put("export_col_month", Res.string.export_col_month)
  map.put("export_col_overtime_100", Res.string.export_col_overtime_100)
  map.put("export_col_overtime_50", Res.string.export_col_overtime_50)
  map.put("export_col_paid_hours", Res.string.export_col_paid_hours)
  map.put("export_col_planned_gross", Res.string.export_col_planned_gross)
  map.put("export_col_planned_hours", Res.string.export_col_planned_hours)
  map.put("export_col_refunds", Res.string.export_col_refunds)
  map.put("export_col_sick_days", Res.string.export_col_sick_days)
  map.put("export_col_sick_pay", Res.string.export_col_sick_pay)
  map.put("export_col_sunday_holiday", Res.string.export_col_sunday_holiday)
  map.put("export_col_supplements", Res.string.export_col_supplements)
  map.put("export_col_vacation_days", Res.string.export_col_vacation_days)
  map.put("export_download", Res.string.export_download)
  map.put("export_limit_reached", Res.string.export_limit_reached)
  map.put("export_my_data", Res.string.export_my_data)
  map.put("export_my_data_text", Res.string.export_my_data_text)
  map.put("export_ready_text", Res.string.export_ready_text)
  map.put("export_ready_title", Res.string.export_ready_title)
  map.put("export_save_as", Res.string.export_save_as)
  map.put("export_save_failed", Res.string.export_save_failed)
  map.put("export_saved", Res.string.export_saved)
  map.put("export_share", Res.string.export_share)
  map.put("export_sign_in_again", Res.string.export_sign_in_again)
  map.put("export_sign_in_again_text", Res.string.export_sign_in_again_text)
  map.put("export_sign_out", Res.string.export_sign_out)
  map.put("export_working", Res.string.export_working)
  map.put("export_workplace", Res.string.export_workplace)
  map.put("export_workplace_text", Res.string.export_workplace_text)
  map.put("feature_announcements", Res.string.feature_announcements)
  map.put("feature_availability", Res.string.feature_availability)
  map.put("feature_checklists", Res.string.feature_checklists)
  map.put("feature_clock", Res.string.feature_clock)
  map.put("feature_finances", Res.string.feature_finances)
  map.put("feature_hiring", Res.string.feature_hiring)
  map.put("feature_pay", Res.string.feature_pay)
  map.put("feature_reports", Res.string.feature_reports)
  map.put("feature_requests", Res.string.feature_requests)
  map.put("feature_roster", Res.string.feature_roster)
  map.put("feature_settings", Res.string.feature_settings)
  map.put("feature_takings", Res.string.feature_takings)
  map.put("feature_team", Res.string.feature_team)
  map.put("feature_templates", Res.string.feature_templates)
  map.put("feature_tips", Res.string.feature_tips)
  map.put("feature_training", Res.string.feature_training)
  map.put("field_required", Res.string.field_required)
  map.put("file_drop_here", Res.string.file_drop_here)
}
